'use strict';

module.exports = function initUserTypeToggle() {
    const $ = window.$;
    if (!$) {
        return;
    }

    $(document).on('click', '.content-user-type .user-type', function(e) {
        if ($(e.target).is('input[type="radio"]')) {
            return;
        }

        const $radio = $(this).find('input[type="radio"]');
        if ($radio.length) {
            $radio.prop('checked', true).trigger('change');
        }
    });
};
